import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import BottomNav from "./BottomNav";

/**
 * App shell: centered 480px column with a fixed BottomNav.
 * Used as a layout route for the 4 tab screens.
 */
export default function AppShell() {
  const { pathname } = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => {
    mainRef.current?.scrollTo(0, 0);
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div
      style={{
        maxWidth: 480,
        marginInline: "auto",
        height: "var(--tg-viewport-stable-height, 100dvh)",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <main
        ref={mainRef}
        style={{
          flex: 1,
          overflowY: "auto",
          paddingBottom: "calc(80px + env(safe-area-inset-bottom, 0px))",
        }}
      >
        <Outlet />
      </main>

      <BottomNav />
    </div>
  );
}
